import React from "react";
import Navbar from "../navbar/Navbar";
import Footer from "../../share/Footer/Footer";
import { Outlet } from "react-router-dom";

const Layout = () => {
    return (
        <>
            <Navbar />
            <main className="bg-[#f0f0f0] ">
                <Outlet />
            </main>
            <Footer />
        </>
    );
};
export default Layout;
